<template lang="pug">
    .component-statistics-card-4
        .row
            .columns.card
                .inner-content
                    slot(name="n1")
            .columns.card
                .inner-content
                    slot(name="n2")
            .columns.card
                .inner-content
                    slot(name="n3")
            .columns.card
                .inner-content
                    slot(name="n4")
            .columns.card
                .inner-content
                    slot(name="n5")
            .columns.card
                .inner-content
                    slot(name="n6")
            .columns.card
                .inner-content
                    slot(name="n7")

</template>
<script type="text/babel">
    export default{
        name: "StatisticsCard7",
        components: {},
        data(){
            return {}
        },
        created() {
        },
        methods: {},
        computed: {}
    }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>


// WEBPACK FOOTER //
// StatisticsCard7.vue?ad45bd96